var ThemeTitle;
(function (ThemeTitle) {
  ThemeTitle["light"] = "Light";
  ThemeTitle["dark"] = "Dark";
  ThemeTitle["auto"] = "Sync with system";
})(ThemeTitle || (ThemeTitle = {}));

export { ThemeTitle };
